module.exports = {
	locales: ['cs', 'en', 'fr'],
	defaultLocale: 'cs',
	localeDetection: false,
}
